import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { style: {"width":"100%","text-align":"center"} }
const _hoisted_3 = { style: {"width":"100%","text-align":"center"} }

import { reactive, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { User,Lock,Iphone,Message } from '@element-plus/icons-vue';
import $http from '../http/index';
import $helper from '../helper/helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  emits: ['loginComplete','gotoRegist'],
  setup(__props, { emit }) {


class InitData{
    loginType='1' //登录方式 1：密码登录   2：验证码登录
    account=''
    password=''
    phone=''
    code=''
    passwordLoginStyle={
        'cursor': 'pointer',
        'color':'#FF0000'
    }
    verificationCodeLoginStyle={
        'cursor': 'pointer',
        'color':''
    }
    countdown=0
    codeButtonState=true;//验证码按钮状态
    codeButtonText="获取验证码"
}
const data = reactive(new InitData());

watch(()=>data.loginType,()=>{
    if(data.loginType=="1"){
        data.passwordLoginStyle.color='#FF0000';
        data.verificationCodeLoginStyle.color='';
        return;
    }
    if(data.loginType=="2"){
        data.passwordLoginStyle.color='';
        data.verificationCodeLoginStyle.color='#FF0000';
        return;
    }
});

/**
 * 设置登录方式
 * @param t 1：密码登录   2：验证码登录
 */
const setLoginType =(t:string)=>{
    data.loginType=t;
}

/**
 * 登录
 */
const login=()=>{
    if(data.loginType=="1"){
        loginByAccountAndPassword()
        return;
    }
    if(data.loginType=="2"){
        loginByPhoneAndCode()
        return;
    }
}

/**
 * 通过账号密码登录
 */
const loginByAccountAndPassword=()=>{
    $http({
        url: `/API/FrontEndUser/LoginByAccountAndPassword`,
        method: "post",
        data: {
            account:data.account,
            password:data.password
        }
    }).then(res => {
        window.localStorage.setItem("userInfo",JSON.stringify(res.data));
        data.account='';
        data.password=''
        emit("loginComplete");
    });
}

/**
 * 游客入口
 */
const touristEntrance=()=>{
    emit("loginComplete");
}

/**
 * 注册入口
 */
const gotoRegist=()=>{
    emit("gotoRegist");
}

/**
 * 发送登录验证码
 */
const sendLoginVerificationCode=()=>{
    if(!data.phone){
        ElMessage({
            showClose: false,
            message: '手机号不能为空',
        })
        return;
    }
    if(data.phone.length!=11){
        ElMessage({
            showClose: false,
            message: '手机号需为11为数字',
        })
        return;
    }
    if(data.countdown>0){
        return;
    }
    data.countdown = 60; // 倒计时的秒数 
    let intervalId = setInterval(function() {  
        data.codeButtonText = `再次获取${data.countdown}`
        data.countdown--;  
        if(data.countdown <= 0) {  
            data.codeButtonText="获取验证码"
            clearInterval(intervalId); // 当倒计时结束时，停止倒计时  
        }  
    }, 1000); // 每秒执行一次
    $http({
        url: `/API/FrontEndUser/SendLoginVerificationCode`,
        method: "post",
        data: {
            phone:data.phone,
        }
    });
}

/**
 * 验证码登录
 */
const loginByPhoneAndCode=()=>{
    if(!data.phone){
        ElMessage({
            showClose: false,
            message: '手机号不能为空',
        })
        return;
    }
    if(data.phone.length!=11){
        ElMessage({
            showClose: false,
            message: '手机号需为11为数字',
        })
        return;
    }
    if(!data.code){
        ElMessage({
            showClose: false,
            message: '验证码不能为空',
        })
        return;
    }
    $http({
        url: `/API/FrontEndUser/LoginByPhoneAndCode`,
        method: "post",
        data: {
            phone:data.phone,
            code:data.code
        }
    }).then(res => {
        window.localStorage.setItem("userInfo",JSON.stringify(res.data));
        data.phone='';
        data.code=''
        emit("loginComplete");
    });
}



return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, { class: "loginRow" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 24,
          style: {"text-align":"center","font-size":"26px"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("b", null, _toDisplayString(_unref($helper).lan('用户中心')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { class: "loginRow" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", {
                style: _normalizeStyle(data.passwordLoginStyle),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (setLoginType('1')))
              }, _toDisplayString(_unref($helper).lan('密码登录')), 5)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", {
                style: _normalizeStyle(data.verificationCodeLoginStyle),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (setLoginType('2')))
              }, _toDisplayString(_unref($helper).lan('验证码登录')), 5)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (data.loginType=='1')
      ? (_openBlock(), _createBlock(_component_el_row, {
          key: 0,
          class: "loginRow"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: _unref($helper).lan('填写账号'),
                  modelValue: data.account,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((data.account) = $event))
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_el_button, { icon: _unref(User) }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["placeholder", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (data.loginType=='1')
      ? (_openBlock(), _createBlock(_component_el_row, {
          key: 1,
          class: "loginRow"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: _unref($helper).lan('填写密码'),
                  modelValue: data.password,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((data.password) = $event)),
                  type: "password"
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_el_button, { icon: _unref(Lock) }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["placeholder", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (data.loginType=='2')
      ? (_openBlock(), _createBlock(_component_el_row, {
          key: 2,
          class: "loginRow"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: _unref($helper).lan('填写手机号'),
                  modelValue: data.phone,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((data.phone) = $event))
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_el_button, { icon: _unref(Iphone) }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["placeholder", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (data.loginType=='2')
      ? (_openBlock(), _createBlock(_component_el_row, {
          key: 3,
          class: "loginRow"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  placeholder: _unref($helper).lan('输入验证码'),
                  modelValue: data.code,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((data.code) = $event))
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_el_button, { icon: _unref(Message) }, null, 8, ["icon"])
                  ]),
                  append: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      text: "",
                      onClick: sendLoginVerificationCode,
                      disabled: !data.codeButtonState
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref($helper).lan(data.codeButtonText)), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _: 1
                }, 8, ["placeholder", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_row, { class: "loginRow" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "danger",
              style: {"width":"100%"},
              onClick: login
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref($helper).lan('登录')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { class: "loginRow" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              style: {"width":"100%","color":"#CCCCCC","cursor":"pointer"},
              onClick: touristEntrance
            }, _toDisplayString(_unref($helper).lan('游客入口')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              style: {"text-align":"right","color":"#FF0000","cursor":"pointer","float":"right"},
              onClick: gotoRegist
            }, _toDisplayString(_unref($helper).lan('注册账号')) + ">>", 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})